import { useEffect } from 'react'

import { useLocation } from 'react-router-dom'

import { DealComponent } from '../../components/Deal'
import { LayoutPage } from '../../components/LayoutPage'
import { PaginationComponent } from '../../components/Pagination'
import { SpinnerComponent } from '../../components/Spinner'

import { useControlSearch } from '../../hooks/useControlSearch'
import { useView } from '../../hooks/useView'

import dayjs from 'dayjs'

import './index.css'

const SearchResultsPage = () => {
    const location = useLocation()

    const {_view} = useView({
        initialView: 'loading',
        views: {
            loading: renderLoading,
            main: renderMain
        }
    })

    const {_control, _results, _pagination, _params} = useControlSearch({
        params: { q: new URLSearchParams(location.search).get('q') || '' },
        afterFetch: () => {
            _view.set('main')
        }
    })

    useEffect(() => {
        let newQ = new URLSearchParams(location.search).get('q') || ''

        if (newQ !== _params.get('q')) {
            _view.set('loading')
            _params.set('q', newQ)
        }
    }, [location.search])

    const handlePageChange = (page) => {
        _view.set('loading')
        _control.goToPage(page)
    }

    const handleDealClick = (item) => {
        _control.fetchClick(item)

        setTimeout(() => {
            window.open(item.url, '_blank')
        }, 500)
    }

    const handleDealClickDead = (item) => {
        _control.fetchClickDead(item)
    }

    const getList = () => {
        const deals = _results.get()?.body?.data

        if (!deals?.length) {
            return (
                <div className="searchResults-noResults">
                    <h2>No Results</h2>
                    <p>Try a different search.</p>
                </div>
            )
        }

        return deals.map((item, index) => (
            <div className="searchResults-section" key={`searchResults-section-${item.date}-${index}`}>
                <div className="searchResults-sectionDate">
                    <span className="bubble bubble-green">{dayjs(item.date).format('MMMM D, YYYY')}</span>
                </div>

                <div className="searchResults-sectionItems">
                    {item.items.map((itm) => (
                        <DealComponent value={itm} key={`deal-${itm.id}`} events={{
                            handleClick: handleDealClick,
                            handleClickDead: handleDealClickDead
                        }} />
                    ))}
                </div>
            </div>
        ))
    }

    function renderLoading() {
        return (
            <div className="searchResults-results">
                <SpinnerComponent />
            </div>
        )
    }

    function renderMain() {
        return (
            <div className="searchResults-results">
                <div className="searchResults-collection">
                    {getList()}
                </div>

                <PaginationComponent
                    value={_pagination.get('page')}
                    config={{ lastPage: _pagination.get('lastPage') }}
                    events={{ handleChange: handlePageChange }}
                />
            </div>
        )
    }

    return (
        <LayoutPage config={{ id: 'SearchResults' }}>
            <div className="c-SearchResults">
                {_view.get()}
            </div>
        </LayoutPage>
    )
}

export { SearchResultsPage }
